<template>
  <div class="select-box-wrapper">
    <select :class="selectClasses"
            v-model="selectedItem"
            @change="actionOnChange">
      <option v-if="placeholder" class="placeholder-option" :value="null">{{placeholder}}</option>
      <option v-for="option in options" :value="option.value">{{option.text}}</option>
    </select>
  </div>
</template>

<script>
  export default {
    props: {
      options: Array,
      placeholder: String,
      selectClasses: String,
      selectId: [Number, String],
      selectedOption: [Number, String],
    },

    name: 'SelectBox',

    components: {},

    data () {
      return {
        selectedItem: null
      }
    },

    methods: {
      actionOnChange() {
        this.$emit('setInteractions')
        if (this.selectedItem !== this.selectedOption) {
          this.$emit('saveInput', this.selectedItem)
        }
      },
    },

    created() {
      this.selectedItem = this.selectedOption
    },

    watch: {
      selectedOption: function() {
        this.selectedItem = this.selectedOption
      }
    }
  }
</script>